module.exports = __webpack_public_path__ + "static/media/megaphone.8cef0050.svg";